import React, { useState } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

import constant from "./utils/constant";
import AlefbaGroup from "../../images/demo/alefba-group.png";
import SolidUserIcon from "../icons/solid-user-icon";
import LogoutIcon from "../icons/logout-icon";
import { LogoIcon } from "../../images";
import { ArchiveIcon, SpeechIcon } from "../../images";
import { useDispatch } from "react-redux";
import { changeState } from "../../services/state/search";
import { handleLogout } from "../../services/logout";

const Sidebar = () => {
  // TODO: Dont remove code below - maybe usefull later 👇
  // const searchResultsState = useSelector((state) => state.search.active);
  const dispatch = useDispatch();
  const logoutHandler = () => {
    handleLogout();
  };
  const pathname = window.location.pathname;
  const [showTooltip, setShowTooltip] = useState(false);

  const hoverHandler = () => {
    setShowTooltip(true);
  };

  const hoverOutHandler = () => {
    setShowTooltip(false);
  };

  const handleSpeechClick = () => {
    dispatch(changeState(false)); // Reset search state
  };

  return (
    <aside className='sidebar' dir='rtl'>
      <LogoIcon />
      <div className='spacer-1'></div>
      <div className='nav'>
        <Link
          to='/'
          onClick={handleSpeechClick}
          style={{
            backgroundColor: pathname === "/" ? "#02816e" : "transparent",
          }}
        >
          <SpeechIcon />
          <span>تبدیل گفتار</span>
        </Link>
        <Link
          to='/archive'
          style={{
            backgroundColor:
              pathname === "/archive" ? "#02816e" : "transparent",
          }}
        >
          <ArchiveIcon />
          <span>آرشیو</span>
        </Link>
      </div>
      <div className='sidebar-user' dir='ltr'>
        <div className={clsx("user-tooltip", showTooltip && "show-tooltip")}>
          <span>مهمان</span>
        </div>
        <div
          className='user'
          onMouseOver={hoverHandler}
          onMouseLeave={hoverOutHandler}
        >
          <span>مهمان</span>
          <SolidUserIcon width={30} height={30} />
        </div>
        <div className='devider' />
        <div className='logout' onClick={logoutHandler}>
          <span>خروج</span>
          <LogoutIcon width={20} height={23} />
        </div>
      </div>
      <div className='spacer-2'></div>
      <img
        src={AlefbaGroup}
        alt='harf - convert audio/voice to text'
        className='sidebar-cover'
      />
    </aside>
  );
};

export default Sidebar;
